import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", href: "#hero" },
  { label: "Capabilities", href: "#capabilities" },
  { label: "Contracting Information", href: "#contracting" },
  { label: "About Atlas", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 relative flex items-center justify-center h-20">
        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`navlink-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="inline-flex items-center leading-none font-mono text-xs uppercase tracking-[0.18em] text-neutral-400 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="navbar-quote-btn"
            className="inline-flex bg-white text-black font-sans font-bold uppercase tracking-widest text-sm px-5 py-2.5 hover:bg-neutral-300 transition-colors"
          >
            Request a Quote
          </a>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          className="lg:hidden absolute right-6 md:right-12 text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#0A0A0A] border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-mono text-sm uppercase tracking-widest text-neutral-300 hover:text-white"
            >
              {l.label}
            </a>
          ))}
          <a href="#contact" onClick={() => setOpen(false)} className="mt-2 bg-white text-black font-sans font-bold uppercase tracking-widest text-sm px-5 py-3 text-center">
            Request a Quote
          </a>
        </div>
      )}
    </header>
  );
};
